<template>
	<div style="background: #F6F6F6;padding-bottom: 50px;position: relative;">
		<div class="head">
			<div class="wrap" style="padding-top:0px">
				<div class="headbox">
					<img src="../../assets/images/logo_02.png" class="logo" />
					<div class="navbox" id="step3" style="height:100%">
						<div class="navtxt" @click="$router.push('/allsearchRefine/xmxqC')">项目需求池</div>
						<div class="navtxt" @click="$router.push('/ResourceTools')">资源工具池</div>
						<div class="navtxt" @click="$router.push('/searchIndex/Solution')">解决方案池</div>
						<div class="navtxt" @click="$router.push('/searchIndex/productService')">产品服务池</div>
						<div class="navtxt">牛人俱乐部</div>
					</div>
					<!-- <div class="zhubox">
						<div class="zhutxt" @click="gotologin()">
							登录
						</div>
						<div class="zhuline"></div>
						<div class="zhutxt">
							注册
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<div class="wrap">
			<div class="left">
				<div class="left-top-user" id="step1">
					<div class="toux">
						<div>
							<img :src='getImgSrc($store.state.userInfo.avatar)' alt="">
						</div>
					</div>
					<p style="margin-top: 15px;text-align: center;">{{$store.state.userInfo.nickname}}，欢迎您！</p>
					<div class="qiehuan">
						切换为企业/小组管理
					</div>
				</div>
				<div class="body-left">
					<div class="body-left-item">
						<el-collapse v-model="activeNames" @change="handleChange" class="collapse">
							<el-collapse-item name="1">
								<template slot="title">
									<img src='../../assets/images/perinfo .png' style="width: 19px;height: 19px;"
										alt=""><span style="margin-left: 8px;">个人数据</span>
								</template>
								<div class="collapse-inner">
									<p v-for="(item, index) in cities" :key="index"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;color: #222222;margin: 15px;cursor: pointer;font-size: 16px;">
										{{ item }}
									</p>
								</div>

							</el-collapse-item>
							<el-collapse-item name="2">
								<template slot="title">
									<img src='../../assets/images/flyicon.png' style="width: 19px;height: 19px;"
										alt=""><span style="margin-left: 8px;">平台活动</span>
								</template>
								<div class="collapse-inner">
									<p v-for="(item, index) in cities2" :key="index"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;color: #222222;margin: 15px;cursor: pointer;font-size: 16px;">
										{{ item }}
									</p>
								</div>

							</el-collapse-item>
							<el-collapse-item name="3">
								<template slot="title">
									<img src='../../assets/images/xiaoxi.png' style="width: 22px;height: 18px;"
										alt=""><span style="margin-left: 8px;">消息</span>
								</template>
								<div class="collapse-inner">
									<p v-for="(item, index) in cities3" :key="index"
										style="font-size: 16px;font-family: PingFang;font-weight: 400;color: #222222;margin: 15px;cursor: pointer;font-size: 16px;">
										{{ item }}
									</p>
								</div>

							</el-collapse-item>
							<div id="step2">
								<el-collapse-item name="4">
									<template slot="title">
										<img src='../../assets/images/team.png' style="width: 22px;height: 18px;"
											alt=""><span style="margin-left: 8px;">我的组织</span>
									</template>
									<div class="collapse-inner">
										<p v-for="(item, index) in cities4" :key="index"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;color: #222222;margin: 15px;cursor: pointer;font-size: 16px;">
											{{ item }}
										</p>
									</div>

								</el-collapse-item>
								<el-collapse-item name="5">
									<template slot="title">
										<img src='../../assets/images/setting.png' style="width: 19px;height: 19px;"
											alt=""><span style="margin-left: 8px;">个人设置</span>
									</template>
									<div class="collapse-inner">
										<p v-for="(item, index) in cities5" :key="index"
											style="font-size: 16px;font-family: PingFang;font-weight: 400;color: #222222;margin: 15px;cursor: pointer;font-size: 16px;">
											{{ item }}
										</p>
									</div>

								</el-collapse-item>
							</div>

						</el-collapse>
					</div>

				</div>
			</div>
			<div class="midlle">
				<div class="midller-top">
					<div class="top-item">
						<div class="header">
							<div>
								核心用户(正式)
							</div>
							<div
								style="width: 79px;height: 27px;background: #0052D9;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 27px;">
								已认证
							</div>
						</div>
						<p style="margin-top: 10px; font-size: 14px;
																									font-family: PingFang;
																									font-weight: 400;color: #0052D9;">科研用户、高校认证用户、企业名称</p>
						<div class="clounm">
							<div class="title">
								<span class="justi">当前特权</span>: <span
									style="font-weight: normal;color: #636363;">每日不限分享，求组：资源限量+10</span>
							</div>
						</div>
						<div class="clounm">
							<div class="title">
								<span class="justi">关注人数</span>: <span
									style="font-weight: normal;color: #636363;">1k</span>
							</div>
						</div>
						<div class="clounm">
							<div class="title">
								<span class="justi">勋章</span>: <span
									style="font-weight: normal;color: #636363;">伯乐3级</span>
							</div>
						</div>
					</div>
					<div class="top-item">
						<div style="margin-top: 0;">
							<span style="font-weight: bold;">积分：</span> <span
								style="font-weight: normal;color: #636363;">永久3500&ensp;当日50分</span>
						</div>
						<div style="margin-top: 15px;">
							<span style="font-weight: bold;">活跃：</span> <span
								style="font-weight: normal;color: #636363;">无人不识&ensp;(5k-20k)</span>
						</div>
						<div style="margin-top: 15px;">
							<span style="font-weight: bold;">声望：</span> <span
								style="font-weight: normal;color: #636363;">伯乐3级</span>
						</div>
						<div style="margin-top: 15px;">
							<span style="font-weight: bold;">贡献：</span> <span
								style="font-weight: normal;color: #636363;">伯乐3级</span>
						</div>
						<div style="margin-top: 15px;">
							<span style="font-weight: bold;">背书：</span> <span
								style="font-weight: normal;color: #636363;">伯乐3级</span>
						</div>
					</div>
				</div>
				<div class="midlle-body">
					<div class="body-title">
						<div class="line"></div>
						<div style="margin-left: 20px;">激活中的平台活动</div>
					</div>
					<el-table :data="tableData" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="type" label="类型" width="105" :resizable="false">
						</el-table-column>
						<el-table-column prop="role" label="角色" width="76" :resizable="false">
						</el-table-column>
						<el-table-column prop="title" label="标题" width="150" :resizable="false">
						</el-table-column>
						<el-table-column prop="status" label="状态" width="87" :resizable="false">
						</el-table-column>
						<el-table-column prop="date" label="当前状态开始时间" width="136" :resizable="false">
						</el-table-column>
						<el-table-column prop="name" label="当前状态用户" width="134" :resizable="false">

						</el-table-column>

						<el-table-column label="当前状态用户" width="130" :resizable="false">
							<div class="link" style="color: #0052D9 !important;">查看详情</div>
						</el-table-column>

					</el-table>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
				</div>
				<div class="midlle-body">
					<div class="body-title">
						<div class="line"></div>
						<div style="margin-left: 20px;">您关注的内容</div>
					</div>
					<div class="table">
						<div class="table-item" v-for="(item, index) in 6" :key="index"
							:style="index % 2 == 0 ? 'background: #FAFAFA;' : ''">
							<div style="display: flex;align-items: center;">
								<img style="width: 18px;height: 16px;" src='../../assets/images/text.png' alt="">
								<span style="margin-left: 15px;">您关注的自行车机破解哦哦</span>
							</div>
							<div class="detail">
								查看详情
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
				</div>
				<div class="midlle-body">
					<div class="body-title">
						<div class="line"></div>
						<div style="margin-left: 20px;">您关注的内容</div>
					</div>
					<el-table :data="tableData2" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="type" label="类型" width="140" :resizable="false">
						</el-table-column>

						<el-table-column prop="title" label="标题" width="185" :resizable="false">
						</el-table-column>

						<el-table-column prop="date" label="当前状态开始时间" width="170" :resizable="false">
						</el-table-column>
						<el-table-column prop="name" label="当前状态用户" width="170" :resizable="false">

						</el-table-column>

						<el-table-column label="查看详情" width="154" :resizable="false">
							<div class="link" style="color: #0052D9 !important;">
								<span>收藏</span>
								<span>转发</span>
								<span>查看</span>
							</div>
						</el-table-column>

					</el-table>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
				</div>
				<div class="midlle-body">
					<div class="body-title">
						<div class="line"></div>
						<div style="margin-left: 20px;">我的平台活动</div>
					</div>
					<div style="display:flex;align-items: center;justify-content: space-between;padding: 0 15px;">
						<div style="display:flex;align-items: center;">
							<el-select v-model="value" id="selectInp" style="" placeholder="全部类型">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<div style="display: flex;align-items: baseline;cursor: pointer;margin-left: 15px;">
								时间<img src="../../assets/images/shaixuan.png" alt="" style="width: 15px;height: 13px;">
							</div>
						</div>
						<el-checkbox-group v-model="checkedCities">
							<el-checkbox v-for="city in cities6" :label="city" :key="city">{{ city }}</el-checkbox>
						</el-checkbox-group>
					</div>

					<div class="">


					</div>
					<el-table :data="tableData3" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="type" label="类型" width="105" :resizable="false">
						</el-table-column>
						<el-table-column prop="type" label="类别" width="75" :resizable="false">
							<div class="pointer">
								<p>收藏</p>
								<p>转发</p>
								<p>查看</p>
							</div>
						</el-table-column>
						<el-table-column prop="title" label="标题" width="150" :resizable="false">
						</el-table-column>
						<el-table-column prop="status" label="状态" width="87" :resizable="false">
						</el-table-column>
						<el-table-column prop="date" label="当前状态开始时间" width="132" :resizable="false">
						</el-table-column>
						<el-table-column prop="name" label="当前状态用户" width="130" :resizable="false">
						</el-table-column>

						<el-table-column label="查看详情" width="140" :resizable="false">
							<div class="link" style="color: #0052D9 !important;">
								详细列表
							</div>
						</el-table-column>

					</el-table>
					<div style="display: flex;justify-content: flex-end;">
						<div class="loading">
							<img src='../../assets/images/loading.png' alt=""> 加载更多
						</div>
					</div>
				</div>
			</div>
			<div class="body-right">
				<div>
					<img src='../../assets/images/zhifly.png' alt="" style="width: 18px;height: 18px;"><span
						style="width:80px">发布</span>
				</div>
				<div style="background: #18BC9C;">
					<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;"><span
						style="width:80px">草稿箱</span>
				</div>
				<div style="background: orange;">
					<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;"><span
						style="width:80px">版本管理</span>
				</div>
				<div style="background:#0297F8;">
					<img src='../../assets/images/dwen.png' alt="" style="width: 19px;height: 19px;"><span
						style="width:80px">求助</span>
				</div>
				<div style="background:#444C69;">
					<img src='../../assets/images/iicon.png' alt="" style="width: 18px;height: 16px;"><span
						style="width:80px">@我的</span>
				</div>
				<div style="background:#E5F2FF; color: black;">
					<img src='../../assets/images/xiaoxxi.png' alt="" style="width: 18px;height: 16px;"><span
						style="width:80px">我的消息</span>
				</div>
			</div>
			<el-dialog title="让大家认识你" :visible.sync="dialogVisible" width="700px" center :close-on-click-modal="false"
				:show-close="false" :close-on-press-escape="false">
				<div class="form">
					<div class="form-item">
						<div class="inp">
							<span>您的兴趣</span><input type="text" v-model="interstKeywords"
								@change="getInterestList('search')" placeholder="输入以找到最接近的描述">
						</div>
						<div class="main" v-if="interstList.total">
							<div class="main-item" v-for="(item, index) in interstList.data" :key="index"
								:style="checkedInterstTags.includes(item.name)?'background:#0052D9;color:#fff':''"
								@click="AddInterestTags(item.name)">
								<img src="../../assets/images/banshou.png" alt=""> <span>{{ item.name }}</span>
							</div>
							<p v-if="interstList.last_page > 1"
								style="color:#0052D9;text-align: right;width: 100%;padding-right: 15px;">
								<span style="cursor: pointer;" @click="getInterestList('next')">换一批</span>
							</p>
						</div>
						<div v-else style="text-align: center;padding: 40px;color: #666;">
							暂无数据
						</div>
					</div>
					<div class="form-item">
						<div class="inp">
							<span>工作领域</span>
						</div>
						<div class="main">
							<div class="main-item" v-for="(item, index) in hangYeList" :key="item.id"
								:style="checkedHangYeList.includes(item.id)?'background:#0052D9;color:#fff':''"
								@click="AddHangYeTags(item.id)">
								<img src="../../assets/images/banshou.png" alt=""> <span>{{ item.name }}</span>
							</div>

						</div>
					</div>


				</div>
				<span slot="footer" class="dialog-footer">
					<div @click="nextStep(1)"
						style="width: 188px;height: 40px;background: #0052D9;line-height: 40px;color: white;margin: auto;cursor: pointer;">
						下一步</div>
				</span>
			</el-dialog>
			<el-dialog title="建议关注和收藏" :visible.sync="dialogVisible2" width="700px" center :close-on-click-modal="false"
				:close-on-press-escape="false" top='5vh' :show-close="false">
				<p
					style="font-size: 16px;font-family: PingFang;font-weight: 400;color: #0052D9;text-align: center;position: absolute;top: 50px;left: 50%;transform: translateX(-50%);width: 700px;">
					(关注帮您找到目标,并在被关注对象有更新时得到提醒)</p>
				<div class="form">
					<div class="form-item">
						<div class="inp">
							<span>小组</span><input type="text" v-model="teamKeywords" @change="getTeamList('search')"
								placeholder="输入关键字筛选小组" />
						</div>
						<div class="main" v-if="teamList.total">
							<div style="display:flex;flex-wrap: wrap;">
								<div v-for="(item, index) in teamList.data" :key="item.id">
									<div class="main-item">
										<img src="../../assets/images/banshou.png" alt=""> <span>{{item.name}}</span>
									</div>
									<p style=" text-align: center;margin-bottom: 8px;color: #0052D9;"
										v-if="!checkedTeam.includes(item.id)">
										<span style="cursor: pointer;margin-left: 15px;"
											@click="followTeamHandler(item.id)">关注</span>
									</p>
									<p style=" text-align: center;margin-bottom: 8px;color: #0052D9;" v-else>
										<span style="cursor: pointer;margin-left: 15px;"
											@click="cancelFollowTeamHandler(item.id)">取消关注</span>
									</p>
								</div>
							</div>

							<p v-if="teamList.last_page > 1"
								style="color:#0052D9;text-align: right;width: 100%;padding-right: 15px;">
								<span style="cursor: pointer;" @click="getTeamList('next')">换一批</span>
							</p>
						</div>
						<div v-else style="text-align: center;padding: 40px;color: #666;">
							暂无数据
						</div>
					</div>
					<div class="form-item">
						<div class="inp">
							<span>牛人推荐</span><input type="text" v-model="geniusKeywords"
								@change="getGeniusList('search')" placeholder="输入以找到最接近的描述">
						</div>
						<div class="page-last">
							<div class="page-last-body" v-if="geniusList.total">
								<div class="body-person">
									<div class="body-person-item" v-for="(item, index) in geniusList.data"
										:key="item.id">
										<div class="pgirl"
											style="width: 151px;height: 150px;display:flex;;padding-left:8px;box-sizing: border-box;align-items: center;justify-content: center;">
											<img :src='getImgSrc(item.avatar)' style="width: 100%;height: 100%;" alt="">
										</div>
										<div style="height: 80px;font-size: 16px;">
											<p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
												{{item.nickname}}</p>
											<p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
												{{item.school}}</p>
											<p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
												{{item.qualification}}</p>
										</div>
										<div v-if="item.fans_status == 0" @click='toFansNperson(item)'
											style="width: 82px;height: 38px;background: #0052D9;border-radius: 5px;color: white;line-height: 38px;text-align: center;margin: auto;margin-top: 10px;cursor: pointer;">
											关注 </div>
										<div v-else @click='toCancelFansNperson(item)'
											style="width: 82px;height: 38px;background: #0052D9;border-radius: 5px;color: white;line-height: 38px;text-align: center;margin: auto;margin-top: 10px;cursor: pointer;">
											取消关注</div>
									</div>

								</div>

							</div>
							<div v-else style="text-align: center;padding: 40px;color: #666;">
								暂无数据
							</div>
						</div>
						<p v-if="geniusList.last_page > 1"
							style="color:#0052D9;text-align: right;width: 100%;padding-right: 15px;">
							<span style="cursor: pointer;" @click="getGeniusList('next')">换一批</span>
						</p>
					</div>
					<div class="form-item" style=" margin-top: 20px;">
						<div class="inp">
							<span>平台资源</span><input v-model="instrumentKeywords" @change="getInstrumentList('search')"
								type="text" placeholder="输入以找到最接近的描述">
						</div>
						<div class="body-mid-main" v-if="instrumentList.total">
							<div v-for="(item, index) in instrumentList.data" :key="item.id">
								<div class="main-iteml">
									<div class="main-item-pic">
										<img src='../../assets/images/computer.png' alt="">
									</div>
									<div class="main-item-title" style="overflow: hidden;
													  font-size: 18px;
													  color: black;
													  width: 100%;
													  text-align: center;
													  text-overflow: ellipsis;
													  max-height: calc(2em + 9px);">
										{{item.title}}
									</div>

								</div>
								<p style=" text-align: center;margin-bottom: 8px;color: #0052D9;"  v-if="item.collect == 0">
									<span style="cursor: pointer;margin-left: 15px;" @click='collectasd(item)'>关注</span></p>
									<p style=" text-align: center;margin-bottom: 8px;color: #0052D9;"  v-else>
										<span style="cursor: pointer;margin-left: 15px;" @click='collectasd(item)'>取消关注</span></p>
							</div>

						</div>
						<div v-else style="text-align: center;padding: 40px;color: #666;">
							暂无数据
						</div>
						<p v-if="instrumentList.last_page > 1"
							style="color:#0052D9;text-align: right;width: 100%;padding-right: 15px;">
							<span style="cursor: pointer;" @click="getInstrumentList('next')">换一批</span>
						</p>
					</div>


				</div>
				<span slot="footer" class="dialog-footer">
					<div @click="nextStep(2)"
						style="width: 188px;height: 40px;background: #0052D9;line-height: 40px;color: white;margin: auto;cursor: pointer;">
						下一步</div>
				</span>
			</el-dialog>
			<el-dialog title="让大家认识你" :visible.sync="dialogVisible3" width="700px" center top="8vh"
				:close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
				<div class="form" style="padding:0 20px;">
					<el-form ref="form" label-width="110px" :model="form" label-position="left">
						<el-form-item label="大学">
							<el-input v-model="serveData.university" class="hasBorder" style="margin-top: 10px;"
								placeholder="请输入"></el-input>
						</el-form-item>
						<el-form-item label="研究生">
							<div v-for="(item, index) in serveData.graduate" :key="index">
								<el-input v-model="serveData.graduate[index]" class="hasBorder" style="margin-top: 10px;"
									placeholder="请输入"></el-input>
							</div>
							<img src="../../assets/images/pulsbtn.png"
								style="width: 18px;height: 18px;margin-top: 5px;cursor: pointer;"
								@click="pulsItem('yanjiu')" alt="">
						</el-form-item>
						<el-form-item label="当前单位">
							<div v-for="(item, index) in serveData.user_company_now" :key="index">
								<el-input v-model="serveData.user_company_now[index]" class="hasBorder" style="margin-top: 10px;"
									placeholder="请输入"></el-input>
							</div>
							<img src="../../assets/images/pulsbtn.png"
								style="width: 18px;height: 18px;margin-top: 5px;cursor: pointer;"
								@click="pulsItem('danwei')" alt="">
						</el-form-item><el-form-item label="职业经历">
							<div v-for="(item, index) in serveData.user_company_log" :key="index">
								<el-input v-model="serveData.user_company_log[index]" class="hasBorder" style="margin-top: 10px;"
									placeholder="请输入"></el-input>
							</div>
							<img src="../../assets/images/pulsbtn.png"
								style="width: 18px;height: 18px;margin-top: 5px;cursor: pointer;"
								@click="pulsItem('jingli')" alt="">
						</el-form-item>
						<el-form-item label="职业关键词">
							<div style="display: flex;">
								<div class="leimu" v-for="(item, index) in jobTagList.data" :key="index" @click="chooseJobTag(item.name)"
								:style="checkedJobTags.includes(item.name)?'background:#0052D9;color:#fff':''"
								>
									{{item.name}}
								</div>
								<span style="color:#0052D9;cursor: pointer;" v-if="jobTagList.last_page > 1" @click="getJobTag('next')">换一批</span>
							</div>
							<p style="color: #0052D9;margin-left: 5px;">(可以帮您更快找到需要的东西哦)</p>
							<el-input v-model="serveData.jobtags" class="hasBorder" style="margin-top: 10px;"
								placeholder="请输入，逗号分隔"></el-input>
						</el-form-item>

						<el-form-item label="猜你在想">
							<div style="display: flex;">
								<div class="leimu" v-for="(item, index) in gueesTagList.data" :key="index" @click="chooseGuessTag(item.name)"
								:style="checkedGuessTags.includes(item.name)?'background:#0052D9;color:#fff':''"
								>
									{{item.name}}
								</div>
								<span style="color:#0052D9;cursor: pointer;" v-if="gueesTagList.last_page > 1" @click="getGuessTag('next')">换一批</span>
							</div>
							<el-input v-model="serveData.guess_tags" class="hasBorder" style="margin-top: 10px;"
								placeholder="请输入，逗号分隔"></el-input>
						</el-form-item>
					</el-form>


				</div>
				<span slot="footer" class="dialog-footer"
					style="display:flex;justify-content: space-between;padding-top: 0;">
					<div @click="goUserCenter"
						style="width: 188px;height: 40px;line-height: 40px;color: white;margin: auto;cursor: pointer;border: 1px solid #0052D9;color: #0052D9;">
						更新信息</div>
					<div @click="goUserCenter"
						style="width: 188px;height: 40px;background: #0052D9;line-height: 40px;color: white;margin: auto;cursor: pointer;">
						带我去探索</div>
				</span>
			</el-dialog>
			<div id="zheNeo"></div>
		</div>
		<div id="zheThree"></div>
	</div>
</template>

<script>
	import intro from "../../utils/introConfig.js";
	const cityOptions = ['个人简历', '资质荣誉'];
	const cityOptions2 = ['项目需求', '资源工具', '解决方案', '产品服务', '求助应助'];
	const cityOptions3 = ['站内信', '系统客服'];
	const cityOptions4 = ['新建和管理企业', '新建和管理小组'];
	const cityOptions5 = ['身份认证', '我的订阅', '权限设置', '账号设置'];
	const cityOptions6 = ['发布', '交互', '收藏', '点赞', '转发'];
	export default {

		data() {
			return {
				cities: cityOptions,
				cities2: cityOptions2,
				cities3: cityOptions3,
				cities4: cityOptions4,
				cities5: cityOptions5,
				cities6: cityOptions6,
				checkedCities: [],
				activeNames: ['1', '2', '3', '4', '5'],
				tableData: [{
						type: '项目课题',
						role: '甲方',
						title: 'AI只能软件开发',
						status: '已公布',
						date: '2016-05-02',
						name: ['王先生,', '王小虎'],
						link: '详情链接',
						id: 1
					},
					{
						type: '项目课题',
						role: '甲方',
						title: 'AI只能软件开发',
						status: '已公布',
						date: '2016-05-02',
						name: ['王先生'],
						link: '详情链接'
					},
					{
						type: '项目课题',
						role: '甲方',
						title: 'AI只能软件开发',
						status: '已公布',
						date: '2016-05-02',
						name: ['王先生'],
						link: '详情链接'
					},
					{
						type: '项目课题',
						role: '甲方',
						title: 'AI只能软件开发',
						status: '已公布',
						date: '2016-05-02',
						name: ['王先生'],
						link: '详情链接'
					},
					{
						type: '项目课题',
						role: '甲方',
						title: 'AI只能软件开发',
						status: '已公布',
						date: '2016-05-02',
						name: ['王先生'],
						link: '详情链接'
					},
				],
				tableData2: [{
					type: '项目课题',
					title: 'AI只能软件开发',
					date: '2016-05-02',
					name: ['王先生,', '王小虎'],
					link: '详情链接'
				}],
				tableData3: [{
					type: '项目课题',
					title: 'AI只能软件开发',
					date: '2016-05-02',
					status: '已公布',
					name: ['王先生,', '王小虎'],
					link: '详情链接',
					id: 1
				}],
				//工作领域 1 select
				options1s: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				value1s: '',
				// 下拉框

				options: [{
					value: '选项1',
					label: '项目'
				}, {
					value: '选项2',
					label: '资源'
				}, {
					value: '选项3',
					label: '方案'
				}, {
					value: '选项4',
					label: '产品'
				}, {
					value: '选项5',
					label: '人才'
				}],
				value: '',
				//对话框1
				dialogVisible: false,
				dialogVisible2: false,
				dialogVisible3: false,
				form: {
					school: '',
					yanjiu: [{
						value: ''
					}],
					danWei: [{
						value: ''
					}],
					jingLi: [{
						value: ''
					}],
					key: '',
					guess: '',
				},
				interstKeywords: "",
				interstList: [],
				checkedInterstTags: [],
				hangYeList: [],
				checkedHangYeList: [],
				teamList: [],
				teamKeywords: '',
				checkedTeam: [],
				geniusList: [],
				geniusKeywords: '',
				checkedGenius: [],
				instrumentList: [],
				instrumentKeywords: '',
				serveData:{
					university:'',//河南大学
					graduate:[''],//研究生
					user_company_now:[''],//公司
					user_company_log:[''],//历史公司
					jobtags:'',//数学,物理
					guess_tags:''//猜测1,猜测2
				},
				jobTagList:[],
				checkedJobTags:[],
				gueesTagList:[],
				checkedGuessTags:[],
			}
		},
		beforeDestroy() {
			intro.exit()
		},
		mounted() {
			this.guide()
			this.getInterestList()
			this.getHangYeLists()
			this.getTeamList()
			this.getGeniusList()
			this.getInstrumentList()
			this.getJobTag()
			this.getGuessTag()
		},
		methods: {
			async letPeopelKnowYou(){
				if(this.checkedJobTags.length){
					let str = this.checkedJobTags.join(',')
					this.serveData.jobtags = this.serveData.jobtags + ',' + str
				}
				if(this.checkedGuessTags.length){
					let str = this.checkedGuessTags.join(',')
					this.serveData.guess_tags = this.serveData.guess_tags + ',' + str
				}
				const know = await this.$api.guidancePeopelToKnow({...this.serveData})
			},
			chooseJobTag(name){
				if (this.checkedJobTags.includes(name)) {
				    this.checkedJobTags = this.checkedJobTags.filter(item => item !== name);
				  } else {
				    this.checkedJobTags.push(name);
				  }
			},
			chooseGuessTag(name){
				if (this.checkedGuessTags.includes(name)) {
				    this.checkedGuessTags = this.checkedGuessTags.filter(item => item !== name);
				  } else {
				    this.checkedGuessTags.push(name);
				  }
			},
			async getGuessTag(type){
				if (type == 'next') {
					this.gueesTagList.current_page++
					if (this.gueesTagList.current_page > this.gueesTagList.last_page) this.gueesTagList.current_page = 1
					const list = await this.$api.guidanceGetGuessTag({
						page: this.gueesTagList.current_page
					})
					this.gueesTagList = list.data
				} else {
					const list = await this.$api.guidanceGetGuessTag()
					this.gueesTagList = list.data
				}
			},
			async getJobTag(type){
				if (type == 'next') {
					this.jobTagList.current_page++
					if (this.jobTagList.current_page > this.jobTagList.last_page) this.jobTagList.current_page = 1
					const list = await this.$api.guidanceGetJobTag({
						page: this.jobTagList.current_page
					})
					this.jobTagList = list.data
				} else {
					const list = await this.$api.guidanceGetJobTag()
					this.jobTagList = list.data
				}
			},
			async collectasd(item) {
				let col
				if (item.collect == 0) {
					 col = await this.$api.collectTools({
						id: item.id
					})
					if (col.code == 1) {
						item.collect = 1
						item.collect_num += 1
					}
				} else {
					 col = await this.$api.cancelCollectTools({
						id: item.id
					})
					if (col.code == 1) {
						item.collect = 0
						item.collect_num -= 1
					}
				}

			},	
			async getInstrumentList(type) {
				if (type == 'next') {
					this.instrumentList.current_page++
					if (this.instrumentList.current_page > this.instrumentList.last_page) this.instrumentList
						.current_page = 1
					const list = await this.$api.InstrumentList({
						page_size: 3,
						status: 2,
						keywords: this.instrumentKeywords,
						page: this.instrumentList.current_page
					})
					this.instrumentList = list.data
				} else if (type == 'search') {
					console.log(type);
					this.instrumentList.current_page = 1
					const list = await this.$api.InstrumentList({
						page_size: 3,
						status: 2,
						keywords: this.instrumentKeywords,
						page: this.instrumentList.current_page
					})
					this.instrumentList = list.data
				} else {
					const list = await this.$api.InstrumentList({
						page_size: 3,
						status: 2,
					})
					this.instrumentList = list.data
				}
			},
			async getGeniusList(type) {
				if (type == 'next') {
					this.geniusList.current_page++
					if (this.geniusList.current_page > this.geniusList.last_page) this.geniusList.current_page = 1
					const list = await this.$api.guidanceGetGenuisList({
						page_size: 3,
						keywords: this.geniusKeywords,
						page: this.geniusList.current_page
					})
					this.geniusList = list.data
				} else if (type == 'search') {
					this.geniusList.current_page = 1
					const list = await this.$api.guidanceGetGenuisList({
						page_size: 3,
						keywords: this.geniusKeywords,
						page: this.geniusList.current_page
					})
					this.geniusList = list.data
				} else {
					const list = await this.$api.guidanceGetGenuisList({
						page_size: 3,
					})
					this.geniusList = list.data
				}
			},
			async toCancelFansNperson(item) {
				const fans = await this.$api.cancelGeniusFans({
					user_id: item.id
				})
				if (fans.code == 1) {

					item.fans_status = 0
				}

			},
			async toFansNperson(item) {
				const fans = await this.$api.toFansGenius({
					user_id: item.id
				})
				if (fans.code == 1) {

					item.fans_status = 1
				}
			},
			async getTeamList(type) {
				if (type == 'next') {
					this.teamList.current_page++
					if (this.teamList.current_page > this.teamList.last_page) this.teamList.current_page = 1
					const list = await this.$api.getTeamList({
						keywords: this.teamKeywords,
						page: this.teamList.current_page
					})
					this.teamList = list.data
				} else if (type == 'search') {
					this.teamList.current_page = 1
					const list = await this.$api.getTeamList({
						keywords: this.teamKeywords,
						page: this.teamList.current_page
					})
					this.teamList = list.data
				} else {
					const list = await this.$api.getTeamList({
						keywords: this.teamKeywords
					})
					this.teamList = list.data
				}
			},
			async getHangYeLists() {
				const list = await this.$api.getHangYeLists()
				this.hangYeList = list.data
			},
			async followTeamHandler(id) {
				const add = await this.$api.toFollowTeam({
					group_id: id
				})
				if (add.code == 1) {
					this.checkedTeam.push(id)
					// console.log(this.checkedInterstTags);
				}
			},
			async cancelFollowTeamHandler(id) {
				const cancel = await this.$api.cancelFollowTeam({
					group_id: id
				})
				if (cancel.code == 1) {
					this.checkedTeam = this.checkedTeam.filter(item => item !== id)
					// console.log(this.checkedInterstTags);
				}
			},
			async AddInterestTags(name) {
				const add = await this.$api.guidanceAddInterestTags({
					name: name
				})
				if (add.code == 1) {
					this.checkedInterstTags.push(name)
					console.log(this.checkedInterstTags);
				}
			},
			async AddHangYeTags(id) {
				const add = await this.$api.guidanceAddHangye({
					industry_id: id
				})
				if (add.code == 1) {
					this.checkedHangYeList.push(id)
					console.log(this.checkedInterstTags);
				}
			},
			async getInterestList(type) {
				if (type == 'next') {
					this.interstList.current_page++
					if (this.interstList.current_page > this.interstList.last_page) this.interstList.current_page = 1
					const list = await this.$api.guidanceInterestList({
						keywords: this.interstKeywords,
						page: this.interstList.current_page
					})
					this.interstList = list.data
				} else if (type == 'search') {
					this.interstList.current_page = 1
					const list = await this.$api.guidanceInterestList({
						keywords: this.interstKeywords,
						page: this.interstList.current_page
					})
					this.interstList = list.data
				} else {
					const list = await this.$api.guidanceInterestList({
						keywords: this.interstKeywords
					})
					this.interstList = list.data
				}
			},
			goUserCenter() {
				this.letPeopelKnowYou()
				this.$api.setUserNoFirst()
				this.dialogVisible3 = false
				this.$router.replace('/userCenter')
			},
			pulsItem(who) {
				if (who == 'yanjiu') {
					// console.log(this.form.yanjiu);
					this.serveData.graduate.push('')
				} else if (who == 'danwei') {
					this.serveData.user_company_now.push('')
				} else {
					this.serveData.user_company_log.push('')
				}
			},
			onSubmit() {
				console.log('submit!');
			},
			nextStep(e) {
				if (e == 1) {
					this.dialogVisible = false
					this.dialogVisible2 = true
				}
				if (e == 2) {
					this.dialogVisible2 = false
					this.dialogVisible3 = true
				}

			},
			gotologin() {
				this.$router.push({
					path: '/login'
				})
			},
			handleChange(val) {
				console.log(val);
			},
			cc(row, column, cell, event) {
				console.log(row, column.label, cell, event);
			},
			//新手引导
			guide() {
				const wrap = document.querySelector('.wrap')
				const zheNeo = document.querySelector('#zheNeo')
				zheNeo.classList.add('zhezhaoNeo')


				// zhezhaoNeo.style.width='100px'
				// zhezhaoNeo.style.height='100px'
				// zhezhaoNeo.style.zIndex='100px'

				intro.setOptions({
					skipButton: false,
					buttonClass: 'my-button-class',
					steps: [{
							element: document.querySelector('#zheNeo'), // 定位到相应的元素位置，如果不设置element，则默认展示在屏幕中央
							intro: '这里是您的个人数据、消息、组织和账号管理部分，也可以快速切换到您的活动平台。', // 内容
							position: 'right'
						},
						{
							element: document.querySelector('#step2'), // 定位到相应的元素位置，如果不设置element，则默认展示在屏幕中央
							intro: '这里可以完成实名认证，参加平台活动；也可以创建和加入小组，和伙伴们分享和协同工作；或者注册或加入您的公司，管理你的任务和产品', // 内容
							position: 'right'
						},
						{
							element: document.querySelector('#step3'), // 定位到相应的元素位置，如果不设置element，则默认展示在屏幕中央
							intro: '找资源？点击每个板块浏览或将一切交给输入框', // 内容
							position: 'bottom'
						},
					],

				});
				intro.oncomplete(() => {
					zheNeo.classList.remove('zhezhaoNeo')
					this.dialogVisible = true
				});
				this.$nextTick(() => {
					intro.start();
				})

			}
		}
	}
</script>
<style>
	.el-form-item__label {}

	.el-form-item__label {
		color: black;
		font-size: 18px;
	}

	.my-button-class {
		background: #0052D9;
		color: white;
		height: 30px;
		width: 80px;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
	}

	.hasBorder {
		border: 1px solid #D2D2D2;
		width: 100%;
	}

	.zhezhaoNeo {
		position: absolute;
		background: transparent;
		width: 1100px;
		height: 330px;
		z-index: 999;
		left: 0;
		top: 20px;
	}

	.zhezhaoThree {
		position: absolute;
		background: transparent;
		width: 900px;
		height: 100px;
		z-index: 999;
		right: 300px;
		top: -100px;
	}

	.introjs-skipbutton {
		display: none !important;
	}
</style>
<style scoped lang="less">
	/deep/.el-dialog__footer {
		padding-top: 0;
	}

	.leimu {
		margin-left: 10px;
		cursor: pointer;
		text-align: center;
		width: 100px;
		height: 40px;
		border: 1px solid #D2D2D2;
		&:first-child{
			margin-left: 0px;
		}
	}

	.main-iteml {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 15px;
		box-sizing: border-box;
		margin: 13px;
		width: 180px;
		height: 210px;
		border: 1px solid #BFBFBF;
		transition: all .3s;
	}

	.main-iteml:hover {
		transform: scale(1.03);
		box-shadow: 0 3px 5px #888888;
	}

	.main-item-pic {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		text-align: center;
		line-height: 100px;
		overflow: hidden;

	}

	.main-item-pic>img {
		width: 100%;
		height: 100%;
	}

	.body-mid-main {
		display: flex;
		flex-wrap: wrap;

		justify-content: space-around;
	}


	.body-person-item {
		width: 151px;
		height: 150px;
		background: url('../../assets/images/personBg.png') no-repeat;
		background-position: center bottom;
		background-size: contain;

		& p {
			margin-top: 6px;
			font-size: 18px;
		}
	}

	.body-person {
		display: flex;
		align-items: center;
		justify-content: space-between;
		text-align: center;
	}

	.page-last-body {
		padding: 40px 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.page-last-top {
		display: flex;
		justify-content: space-between;
	}

	.huanyih {
		font-size: 18px;
		width: 110px;
		height: 40px;
		background: #F6F6F6;
		border: 1px solid #E5E5E5;
		text-align: center;
		cursor: pointer;
		line-height: 40px;
		margin-right: 20px;
	}

	.page-last-title {

		width: 120px;
		height: 40px;
		background: #0052D9;
		border-radius: 0px 20px 20px 0px;
		color: white;
		font-size: 22px;
		font-family: PingFang;
		font-weight: 800;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
	}

	.page-last {

		width: 100%;
		height: 350px;
		background: #FFFFFF;
	}

	/deep/.selects {
		margin-left: 15px;

		.el-input__inner {
			color: black;
			width: 100%;
		}

		.el-input__inner::placeholder {
			color: black;
		}

		color: black;
		width:95px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #D2D2D2;
	}

	.body {
		padding: 15px;
		box-sizing: border-box;
		width: 100%;

		.body-item {
			margin-top: 15px;
			display: flex;
			align-items: center;

			.kaitou {
				width: 40px;
				height: 40px;
				background: #EEEEEE;
				font-size: 16px;
				text-align: center;
				line-height: 40px;
			}
		}
	}

	.form {
		box-sizing: border-box;
		width: 100%;

		.main {
			margin: 20px 0;
			display: flex;
			flex-wrap: wrap;

			.main-item {
				cursor: pointer;
				margin-left: 15px;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 140px;
				height: 44px;
				border: 1px solid #D2D2D2;

				img {
					margin-right: 8px;
				}
			}

			.main-item:hover {
				background: #0e6af4;
				color: white;
			}
		}

		.inp {
			align-items: center;
			display: flex;
			font-size: 18px;
			font-family: PingFang;
			font-weight: 500;

			span {
				width: 72px;
				color: #222222;
			}

			input {
				font-size: 18px;

				flex: 1;
				margin-left: 15px;
				box-sizing: border-box;
				padding-left: 10px;
				width: 500px;
				height: 47px;
				background: #F6F6F6;
			}
		}
	}

	/deep/ .introjs-skipbutton {
		display: none;
	}

	/deep/.el-dialog__title {
		font-size: 20px;
		font-weight: bold;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}

	/deep/ .el-select__caret {
		color: black !important;
	}

	/deep/#selectInp::placeholder {
		color: black !important;
	}

	/deep/.el-input__inner {
		border: none;
		// width: 120px;
	}

	/deep/.el-checkbox {
		display: inline;
		color: #222222;


	}

	.el-dropdown-link {
		cursor: pointer;
		color: black;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.table {
		.table-item {
			align-items: center;
			display: flex;
			padding: 0 20px;
			justify-content: space-between;
			height: 55px;

		}

	}

	.pointer {
		p {
			cursor: pointer;
			margin-bottom: 3px;
		}

		p:hover {
			color: #0052D9;
		}
	}

	.loading {
		cursor: pointer;
		width: 116px;
		height: 40px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		margin: 10px;
		margin-bottom: 0;
		justify-content: center;
	}

	.body-title {
		color: #0052D9;
		display: flex;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;

		.line {
			width: 4px;
			height: 22px;
			background: #0052D9;
		}
	}

	.midlle-body {
		padding-bottom: 10px;

		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}

		margin-top: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		background: white;
	}

	// is-leaf el-table__cell
	/deep/.el-table__cell {
		text-align: center;
		color: #222222;
	}

	/deep/.el-table th.el-table__cell.is-leaf {
		background: #E5EDFB;
		color: #222222;
		border: 1px solid white;
		border-top: none;
	}

	.midlle {
		width: 860px;
		padding: 0 20px;
		box-sizing: border-box;

		.midller-top {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.top-item {
				.clounm {
					margin-top: 15px;
					display: flex;

					.title {
						font-weight: bold;

						.justi {
							display: inline-block;
							text-align-last: justify;
							text-align: justify;
							width: 65px;
						}
					}
				}

				font-size: 16px;

				.header {
					display: flex;
					justify-content: space-between;
				}

				padding: 20px 0 20px 20px;
				box-sizing: border-box;
				width: 400px;
				height: 205px;
				background: #FFFFFF;
			}
		}
	}

	/deep/.el-collapse-item__content {
		padding-bottom: 0;
	}

	.body-left-item-foot {
		border-top: 1px solid #EEEEEE;
		display: flex;
		justify-content: space-between;
		padding: 15px;
	}

	/deep/.el-icon-arrow-right:before {
		background: white;
		border-radius: 50%;
		color: #0052D9;
	}

	.collapse-inner {
		padding: 10px;
	}

	.checkbox-wrap {
		display: flex;
		justify-content: space-around;
	}

	/deep/.el-checkbox {
		color: #222222;
		display: inline-block;
		position: relative;
	}

	.body-left {
		width: 260px;

	}

	.body-left/deep/.el-collapse-item__header {
		background: #0052D9;
		height: 55px;
		font-size: 18px;
		color: white;
		padding: 0 20px;
	}

	.left {
		.left-top-user {
			.qiehuan {
				margin: 0 auto;
				margin-top: 15px;
				width: 210px;
				height: 46px;
				background: #E5EDFB;
				color: #0052D9;
				text-align: center;
				cursor: pointer;
				line-height: 46px;
			}

			width: 260px;
			height: 261px;
			background: #FFFFFF;
			padding: 30px 25px;
			box-sizing: border-box;
			margin-bottom: 15px;

			.toux {
				display: flex;
				justify-content: center;

				&>div {
					width: 106px;
					height: 106px;
					overflow: hidden;
					border-radius: 50%;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}

	.wrap {
		position: relative;
		display: flex;
		padding-top: 20px;
		box-sizing: border-box;
	}
</style>